import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

const AnimationTeaser = ({
  classNames,
  children,
  animation,
  center = false,
  lessPadding = false,
  noPadding = false
}) => (
  <div
    className={cn(
      'AnimationTeaser',
      { center, noPadding, lessPadding },
      classNames
    )}
  >
    <div className="AnimationTeaser__content">{children}</div>
    <div className="AnimationTeaser__aside">{animation}</div>
  </div>
)

AnimationTeaser.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  animation: PropTypes.node,
  center: PropTypes.bool,
  lessPadding: PropTypes.bool,
  noPadding: PropTypes.bool
}

export default AnimationTeaser
